export const responseMessages = {
	acknowledgeAlarm: `Successfully acknowledged the alarm!`,
	addSectorsSettings: 'Sectors settings have been added!',
	alarmOranUpdated: (name: string) =>`A ${name} has been updated!`,
	alarmUpdated: 'Alarm successfully updated',
	apiDocsExported: 'File is being prepared for export. Check your notifications in a few minutes to download it',
	apiDocsExportedError: 'Error with file generating occurred. Please try again later',
	assetNotRemoved: 'Sorry, the asset can\'t be deleted as it belongs to the active request(s).',
	assetRentAcceptProposalItem: 'Proposed asset successfully accepted',
	assetRentDeclineProposalItem: 'Proposed asset successfully declined',
	assetRentDeclineSuccess: 'Request was successfully declined',
	assetRentProposedDatesForItemSuccess: 'Request successfully updated',
	assetRentRemoveProposalItem: 'Proposed asset successfully removed',
	assetSubTypeCreated: 'Asset subtype has been added!',
	assetSubTypeDeleted: 'Asset subtype has been deleted!',
	assetSubTypeUpdated: 'Asset subtype has been updated!',
	assetTypeCreated: 'Asset type has been added!',
	assetTypeDeleted: 'Asset type has been deleted!',
	assetTypeUpdated: 'Asset type has been updated!',
	assetsGroupHideSuccess: 'The assets have been hidden on the map!',
	assetsGroupShowSuccess: 'The assets have been shown on the map!',
	assignConsistencyCheckRanTemplate: 'Reference template has been assigned!',
	attachedPortalFiles: 'The files have been assigned to milestones!',
	attachedPortalFile: 'The file has been assigned to milestones!',
	unassignedPortalFile: 'The milestones have been unassigned from the file!',
	reassignConsistencyCheckRanTemplate: 'Reference template has been reassigned!',
	assignManyConsistencyCheckRanTemplate: 'Reference template has been assigned/reassigned!',
	unassignConsistencyCheckRanTemplate: 'Reference template has been unassigned!',
	unassignManyConsistencyCheckRanTemplate: 'Reference templates have been unassigned!',
	enableMonitoringConsistencyCheckRanTemplate: 'Monitoring has been enabled!',
	disableMonitoringConsistencyCheckRanTemplate: 'Monitoring has been disabled!',
	manyMonitoringConsistencyCheckRanTemplate: 'Monitoring has been changed!',
	changePassword: 'Success. Your profile password has been changed!',
	clearAlarm: (name: string) => `A ${name} alarm has been cleared!`,
	clearCell: 'The cell has been cleared!',
	clearDataModelConfig: 'Data Model has been cleared!',
	commonValues: 'Assets have been updated',
	createApprovalUnit: 'The approval unit has been created!',
	createAssignmentApprovalUnit: 'Success. Approval units were assigned to the Asset type',
	createBrandingSetup: 'A new setup has been created!',
	createFolderSuccess: 'The folder has been created!',
	createSubfolderSuccess: 'The subfolder has been created!',
	createKaiAssistantError: 'Failed to create Kai Assistant',
	createKaiAssistantSuccess: 'Kai Assistant created successfully',
	createMilestoneSuccess: 'The new milestone has been created!',
	createNetworkElement: (name: string) => `A new ${name} has been added!`,
	createPreset: 'A new preset has been created!',
	createPresetByName: (name: string) => `A new ${name} has been created!`,
	createProjectSuccess: 'The new project has been created!',
	createRequest: 'Success. The outgoing request was successfully created.',
	createRequests: 'Success. The outgoing requests were successfully created.',
	createSiteAndLinkCrowdCell: 'The site has been created and the cell has been linked to it!',
	createTaskSuccess: 'The new task has been created!',
	createTreePresetSuccess: 'The preset has been created!',
	createdAsset: 'The asset has been created!',
	createdCell: 'The cell has been created!',
	createdOrganisation: 'The organisations have been created!',
	createdPolygon: 'Polygon has been created!',
	createdSite: 'The site has been created!',
	createdTechnology: 'The technology has been created!',
	createdUser: 'The user has been created!',
	defaultVendorChanged: 'Default vendor changed',
	deleteDataModelConfig: 'Data Model has been deleted!',
	deleteDataSourceConfigs: 'Configuration files have been deleted!',
	deleteDownloadHistoryFile: 'The file has been deleted!',
	deleteDownloadHistoryFiles: 'The files have been deleted!',
	deleteErrorAssetRequestDocument: 'Error occurred while deleting the file',
	deleteKpiPreset: (name: string) => `The ${name} has been deleted!`,
	deletePolygon: 'Polygon has been deleted!',
	deletePreset: 'The preset has been deleted!',
	deleteSectorsSettings: 'Sectors settings have been deleted!',
	deleteTechnology: 'Technology has been deleted!',
	deleteTemplate: 'The template has been deleted!',
	deleteOperationWindowRule: 'The rule has been deleted!',
	deleteOperationWindowRules: 'The rules have been deleted!',
	deleteTreePresetSuccess: 'The preset has been deleted!',
	deleteValidationRulesConfig: 'Validation rules have been deleted!',
	deletedAssetRequestDocument: 'File has been deleted!',
	disable2Fa: '2FA option has been disabled!',
	disableKaiAssistantError: 'Failed to disable Kai Assistant',
	disableKaiAssistantSuccess: 'Kai Assistant disabled successfully',
	disableLogPMFile: 'Log PM file has been disabled!',
	disableNetworkElement: (name: string) => `${name} has been disabled!`,
	disableNetworkElementsSFTP: (name: string) => `The direct SFTP has been disabled for ${name}!`,
	editBrandingSetup: 'The setup has been changed!',
	editPreset: 'The preset has been changed!',
	emptyFile: 'Uploaded file is empty! Nothing to import.',
	enable2Fa: '2FA option has been enabled!',
	enableKaiAssistantError: 'Failed to enable Kai Assistant',
	enableKaiAssistantSuccess: 'Kai Assistant enabled successfully',
	enableLogPMFile: 'Log PM file has been enabled!',
	enableNetworkElement: (name: string) => `${name} has been enabled!`,
	enableNetworkElementsSFTP: (name: string) => `The direct SFTP has been enabled for ${name}!`,
	error: 'Something went wrong. Please try again!',
	errorFillAll: 'Please fill in all mandatory fields.',
	exportAssetsUpdateRulesSuccess: 'Changes have been saved!',
	exportChartsError: 'Error with file generating occurred. Please try again later',
	exportChartsSuccess: 'File is being prepared for export. Check your notifications in a few minutes to download it',
	exportConfigurationComparisonSuccess: 'File is being prepared for export. Check your notifications in a few minutes to download it.',
	exportCrowdCellConfigSuccess: 'File is being prepared for export. Check your notifications in a few minutes to download it.',
	exportDownloadHistoryFileStarted: 'Your download has started',
	exportDownloadHistoryFilesStarted: `File is being prepared for export. Check your
	<br/>notifications in a few minutes to download it.`,
	exportGoldenSettingsSuccess: 'File is being prepared for export. Check your notifications in a few minutes to download the file.',
	exportStartingNotificationSuccess: 'File is being prepared for export. Check your notifications in a few minutes to download it.',
	exportStartingSuccess: 'File is being prepared for export. Check your email in a few minutes to download the file.',
	generalError: 'Something went wrong. Please try again later',
	generateValidationRulesConfig: 'Validation rules have been generated!',
	goldenSettingsReset: 'Golden settings have been reset.',
	goldenSettingsSet: 'Golden settings have been set.',
	importAssets: 'Import has started in the background. You\'ll get a notification once the import is completed.',
	importSites: 'Import has started in the background. You\'ll get a notification once the import is completed.',
	linkCrowdCellToSite: 'The cell has been linked to the site!',
	linkSiteToAssetSuccess: 'The Site was linked to the Asset!',
	movePortalFilesSuccess: 'The Files have been moved!',
	movePortalFileSuccess: 'The File has been moved!',
	networkElementDeleted: (name: string) => `The ${name} element has been deleted!`,
	networkElementUpdated: (name: string) => `A ${name} has been updated!`,
	nothingIsSelected: 'Nothing is selected',
	oversizeFile: 'File contains more than 5000 records. To import more than 5000 records at a time use CSV',
	presetCreated: 'Preset has been created!',
	rebuildSchema: (name: string) => `The ${name} has been rebuilt!`,
	removeApprovalUnit: 'The approval unit has been deleted!',
	removeAssignmentApprovalUnit: 'Success. Approval units were removed from the Asset type',
	removeKaiAssistantError: 'Failed to remove Kai Assistant',
	removeKaiAssistantSuccess: 'Kai Assistant removed successfully',
	removedAsset: 'The asset has been deleted!',
	removedAssets: 'The assets have been deleted!',
	removedAssetsRequestsList: 'The acquire asset(s) have been deleted!',
	removedBrandingSetup: 'The setup has been deleted!',
	removedBrandingSetups: 'The setups have been deleted!',
	removedCell: 'The cell has been deleted!',
	removedCells: 'The cells have been deleted!',
	removedMilestone: 'The milestone has been deleted!',
	removedMilestones: 'The milestones have been deleted!',
	removedPortalFiles: 'The files have been deleted!',
	removedPortalFile: 'The file has been deleted!',
	removedOrganisation: 'The organisation has been deleted!',
	removedOrganisations: 'The organisations have been deleted!',
	removedProject: 'The project has been deleted!',
	removedProjects: 'The projects have been deleted!',
	removedSite: 'The site has been deleted!',
	removedSites: 'The sites have been deleted!',
	removedTask: 'The task has been deleted!',
	removedFolder: 'The folder has been deleted!',
	removedSubfolder: 'The subfolder has been deleted!',
	removedTasks: 'The tasks have been deleted!',
	removedUser: 'The user has been deleted!',
	removedUsers: 'The users have been deleted!',
	removedUsersExceptAdmins: 'All users, except Admins have been deleted!',
	renameFolder: 'The folder has been renamed!',
	renameSubfolder: 'The subfolder has been renamed!',
	moveFolder: 'The folder has been moved!',
	moveSubfolder: 'The subfolder has been moved!',
	renamePreset: (name: string) => `The ${name} has been renamed!`,
	selectPresetCM: (ids: string[]) => `MO tree is loaded with the merged ${ids.join(', ')}`,
	sendAcquireAsset: 'Assets were added to the Request list. Please review the list and submit request.',
	sendAssetCartRequest: 'The outgoing requests were successfully created.',
	sendQueryAsset: 'The email has been sent! Asset Owner will contact with you!',
	setDefaultKaiAssistant: 'Kai Assistant has been set as default successfully!',
	showedOnMapChanged: 'The status "Showed on Map" has been changed!',
	statusChanged: 'The status has been changed!',
	stopRentingAsset: 'The rental period has been changed.',
	subscribeNetworkElement: (name: string) => `You have been subscribed to the ${name}`,
	swapUser: 'User account has been reassigned!',
	thresholdManagementPreset: (name: string) => `Success. ${name} has been loaded!`,
	unlinkCrowdCellFromSite: 'The cell has been unlinked from the site!',
	unlinkSiteFromAsset: 'The Site was unlinked from the Asset!',
	unlinkSitesFromAsset: 'Selected Sites were unlinked from Assets!',
	unsubscribeNetworkElement: (name: string) => `You have been unsubscribed from the ${name}`,
	updateApprovalUnit: 'The approval unit has been updated!',
	updateAssignmentApprovalUnit: 'Success. Approval units were updated for the Asset type',
	updateErrorAssetRequestDocument: 'Error occurred while updating the file',
	updateGNodeBConfigParameters: 'Configuration has been updated!',
	updateKaiAssistantError: 'Failed to update Kai Assistant',
	updateKaiAssistantSuccess: 'Kai Assistant updated successfully',
	updateMilestoneSuccess: 'The milestone has been updated!',
	updatePolygon: 'Polygon has been updated!',
	updateProjectSuccess: 'The project has been changed!',
	updateStartEndDate: 'The dates were successfully updated!',
	updateTaskSuccess: 'The task has been updated!',
	updateThresholds: 'Thresholds have been updated!',
	updateTreePresetSuccess: 'The preset has been updated!',
	updateUserProfile: 'Success. Your profile has been updated!',
	updateValidationRulesConfig: 'Validation rules have been updated!',
	updatedAsset: 'The asset has been updated!',
	updatedAssetRequestDocument: 'File has been updated!',
	updatedCell: 'The cell has been updated!',
	updatedCommissionSettings: 'Commission settings have been successfully updated!',
	updatedErrorCode: 'The error code has been updated!',
	updatedOrganisation: 'The organisation has been updated!',
	updatedOrganisationSettings: 'The Settings have been updated!',
	updatedSectorsSettings: 'Sectors settings have been updated!',
	updatedSite: 'The site has been updated!',
	updatedSitesCoordinates: 'Sites coordinates were updated!',
	updatedTechnology: 'The technology has been updated!',
	updatedUser: 'The user has been updated!',
	updateOperationWindowRuleNotes: 'The rule notes have been updated!',
	updateOperationWindowRule: 'The rule has been updated!',
	updateTemplateName: 'The template name has been updated!',
	updateTemplateNotes: 'The template notes have been updated!',
	uploadDataSourcesConfig: 'Import has started in the background. You\'ll get a notification once the import is completed.',
	uploadErrorAssetRequestDocument: 'Error occurred while uploading the file',
	uploadLogo: 'IconAvatar’s image has been uploaded!',
	uploadedAssetRequestDocument: 'File has been uploaded!',
	uploadPortalFiles: (name: string) => `File(s) has been uploaded into ${name}!`,
	validationError: 'Field validation is incorrect',
	createConfigurationTemplate: 'Template has been created!',
	createOperationWindowRule: 'Rule has been created!',
	candidateSuccess: `New parameter values have been sent to the Candidate configuration for verification.
	The verification result and the ability to commit changes can be viewed on the Change Monitoring page.`,
	deleteDataSourceConfig: `CM data deletion has started in the background.
		You'll get a notification once the deletion is completed`,
};
